import { makeStyles } from '@material-ui/core/styles';

export const useStylesTable = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  head: {
    backgroundColor: '#fff',
    fontWeight: "bold",
  },
  container: {
    backgroundColor: "#fff"
  },
  footer: {
    backgroundColor: "#fff",
  },
  buttonAction: {
    color: '#fff'
  },

  footer_basic: {
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff'
  },
}));

export const useStylesPagination = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
